const translations = {
    messageUser: 'Contact your company admin to add aircraft to your fleet',
    title: 'No drones yet!'
};

export default translations;
